import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';
import HiddenTag from '@/components_cards/tags/_resource/HiddenTag';
import MissingFieldsTag from '@/components_cards/tags/MissingFieldsTag';
import CancelledTag from '@/components_cards/tags/_resource/CancelledTag';
import CompletedTag from '@/components_cards/tags/_resource/CompletedTag';
import ExpiredTag from '@/components_cards/tags/_resource/ExpiredTag';
import useMissingFields from '@/pages/project-manage/useMissingFields';

export default function StatusTags(props) {
  const { project } = props;

  const { missingFields } = useMissingFields(project);

  if (project.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={project} />
        {!project.data.published && (
          <HiddenTag resource={project} />
        )}
      </div>
    );
  }

  if (project.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={project} />
        {!project.data.published && (
          <HiddenTag resource={project} />
        )}
      </div>
    );
  }

  const expired = isExpired(project.data.endDate);

  if (
    expired ||
    !project.data.published ||
    missingFields.data.length > 0
  ) {
    return (
      <div className="flex space-x-4">
        {expired && (
          <ExpiredTag resource={project} />
        )}
        {!project.data.published && (
          <HiddenTag resource={project} />
        )}
        {missingFields.data.length > 0 && (
          <MissingFieldsTag resource={project} />
        )}
      </div>
    );
  }

  return null;
}

StatusTags.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      cancelled: PropTypes.bool,
      completed: PropTypes.bool,
      published: PropTypes.bool,
      endDate: PropTypes.string
    })
  }).isRequired
};
